import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function CircleSuccess(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0Zm0 21.6c-5.292 0-9.6-4.308-9.6-9.6S6.708 2.4 12 2.4s9.6 4.308 9.6 9.6-4.308 9.6-9.6 9.6zm5.508-14.904L9.6 14.604l-3.108-3.096L4.8 13.2 9.6 18l9.6-9.6Z"
        fill="currentColor"
        style={{strokeWidth: 0.648646}}
      />
    </IconWrapper>
  );
}
